import { useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Menu, X } from "lucide-react";
import { BuyButton } from "./BuyButton";

const NAV = [
  { href: "#libro", label: "Il Libro" },
  { href: "#estratto", label: "Estratto Gratuito" },
  { href: "#benefici", label: "Benefici" },
  { href: "#percorsi", label: "Percorsi Scuole" },
  { href: "#recensioni", label: "Recensioni" },
  { href: "#faq", label: "FAQ" },
];

export const Header = ({ content }) => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-stone-200/60 bg-white/80 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <a href="#libro" className="flex items-center gap-2" data-testid="header-logo-link">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-terracotta text-white">
            <Heart className="h-4 w-4 fill-current" />
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-olive">MetodoEmo</span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" data-testid="header-nav">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.href.slice(1)}`}
              className="text-sm font-medium text-stone-600 transition-colors hover:text-terracotta"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Link to="/admin" className="text-xs font-medium text-stone-400 transition-colors hover:text-olive" data-testid="admin-area-link">
            Area Autore
          </Link>
          <BuyButton url={content.amazon_url} price={content.price} compact testid="header-buy-amazon-button" />
        </div>

        <button
          type="button"
          className="rounded-lg p-2 text-olive lg:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-stone-200/60 bg-white px-4 py-4 lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col gap-3">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.href.slice(1)}`}
                className="rounded-lg px-3 py-2 text-sm font-medium text-stone-700 hover:bg-warm"
              >
                {item.label}
              </a>
            ))}
            <Link to="/admin" className="rounded-lg px-3 py-2 text-sm font-medium text-stone-400" data-testid="mobile-admin-area-link">
              Area Autore
            </Link>
            <div className="pt-2">
              <BuyButton url={content.amazon_url} price={content.price} compact testid="mobile-buy-amazon-button" className="w-full" />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
